var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file 时间选择器
 * @author (zhanghao14)
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classnames from 'classnames';
import moment from 'moment';
import _ from 'lodash-es';

import { noop, classPrefix } from '../../common/util';

import PopperWrap from '../PopperWrap';
import Combobox from './Combobox';

import './TimePicker.less';

var getTimeString = function getTimeString(props, state) {
    return state.newValue ? state.newValue.format(props.format) : '';
};

var generateOptions = function generateOptions(length) {
    var disabledOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var arr = [];
    for (var value = 0; value < length; value++) {
        arr.push({ value: value, disabled: disabledOptions.indexOf(value) >= 0 });
    }
    return arr;
};

/**
 * 参数说明
 * className          可选，自定义样式类名
 * classPrefix        可选，类名前缀
 * format             可选，时间显示格式
 * value              可选，显示的时间
 * width              可选，自定义组件宽度
 * placeHolder        可选，无传入内容时的默认显示文字
 * disableTime        可选，禁选的时间
 * onChange           可选，内容变化时的回调
 * zIndex             可选，下拉层的zIndex
 * preventOverflowEnabled     可选,下拉是否受overflow碰撞影响
 * popupOnBody        可选,下拉是否挂在body上
 */

var TimePicker = function (_Component) {
    _inherits(TimePicker, _Component);

    function TimePicker(props) {
        _classCallCheck(this, TimePicker);

        var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

        _this.onChange = function (value) {
            var _this$props = _this.props,
                onChange = _this$props.onChange,
                format = _this$props.format,
                name = _this$props.name,
                getValue = _this$props.getValue;

            _this.setState({
                newValue: value
            });
            var strValue = value && value.format(format);
            if (getValue && _.isFunction(getValue)) {
                getValue({ name: name, value: strValue });
            }
            onChange && onChange(strValue);
        };

        _this.onClick = function () {
            _this.setState({
                isShowPanel: !_this.state.isShowPanel
            }, function () {
                if (_this.state.isShowPanel) {
                    _this.PopperWrap.update(); // 每次点开下来就重新计算下拉位置
                }
            });
        };

        _this.onCloseByWindow = function () {
            _this.setState({
                isShowPanel: false
            });
        };

        _this.onIconClick = function (e) {
            if (getTimeString(_this.props, _this.state)) {
                _this.setState({
                    isShowClearIcon: false
                });
                e.stopPropagation();
                _this.onChange('');
            }
        };

        _this.onMouseEnter = function () {
            var value = _this.state.newValue ? _this.state.newValue.format(_this.props.format) : '';
            value && _this.setState({
                isShowClearIcon: true
            });
        };

        _this.onMouseLeave = function () {
            _this.setState({
                isShowClearIcon: false
            });
        };

        var newValue = _this.props.value ? moment(_this.props.value, _this.props.format) : null;
        _this.state = {
            isShowPanel: false,
            isShowClearIcon: false,
            newValue: newValue
        };
        _this.FORM_NEED_VALIDATE = 0;
        _this.FORM_NO_NEED_VALIDATE = 1;

        _this.formCallback(_this.props.value, _this.FORM_NO_NEED_VALIDATE);
        return _this;
    }

    _createClass(TimePicker, [{
        key: 'formCallback',
        value: function formCallback(data, type, isDelete) {
            var _props = this.props,
                formFlag = _props.formFlag,
                increment = _props.increment,
                name = _props.name,
                onHandleChange = _props.onHandleChange;


            if (onHandleChange && formFlag && _.isFunction(onHandleChange)) {
                onHandleChange({
                    name: name,
                    value: data
                }, this, type, increment, isDelete);
            }
        }
    }, {
        key: 'isShowHour',
        value: function isShowHour() {
            var format = this.props.format;
            return format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1;
        }
    }, {
        key: 'isShowMinute',
        value: function isShowMinute() {
            return this.props.format.indexOf('m') > -1;
        }
    }, {
        key: 'isShowSecond',
        value: function isShowSecond() {
            return this.props.format.indexOf('s') > -1;
        }
    }, {
        key: 'isUse12Hours',
        value: function isUse12Hours() {
            var format = this.props.format;
            return format.indexOf(' a') > -1 || format.indexOf(' A') > -1;
        }
    }, {
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this._showHour = this.isShowHour();
            this._showMinute = this.isShowMinute();
            this._showSecond = this.isShowSecond();
            this._use12Hours = this.isUse12Hours();
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var newValue = nextProps.value ? moment(nextProps.value, this.props.format) : null;
            if (!_.isEqual(this.props.value, nextProps.value)) {
                this.formCallback(nextProps.value, this.FORM_NEED_VALIDATE);
            }
            this.setState({
                newValue: newValue
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.formCallback(this.props.value, this.FORM_NO_NEED_VALIDATE, true);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _classnames2,
                _classnames3,
                _classnames4,
                _this2 = this;

            var _props2 = this.props,
                placeHolder = _props2.placeHolder,
                classPrefix = _props2.classPrefix,
                format = _props2.format,
                className = _props2.className,
                width = _props2.width,
                disableTime = _props2.disableTime,
                validate = _props2.validate,
                formFlag = _props2.formFlag,
                star = _props2.star,
                tips = _props2.tips,
                label = _props2.label,
                noWarning = _props2.noWarning,
                zIndex = _props2.zIndex,
                preventOverflowEnabled = _props2.preventOverflowEnabled,
                popupOnBody = _props2.popupOnBody;

            var prefixCls = classPrefix + '-time-picker';
            var comboboxColumn = +this._showHour + +this._showMinute + +this._showSecond + +this._use12Hours;
            var columnWidth = 60;
            var inputWidth = width || columnWidth * comboboxColumn;
            var rootClass = classnames((_classnames = {}, _defineProperty(_classnames, className, true), _defineProperty(_classnames, prefixCls + '-root', formFlag), _defineProperty(_classnames, 'margin-bottom-24', !noWarning), _classnames));
            var divClass = classnames((_classnames2 = {}, _defineProperty(_classnames2, prefixCls, true), _defineProperty(_classnames2, prefixCls + '-column-' + comboboxColumn, true), _classnames2));
            var containerProps = {
                className: divClass,
                style: { width: inputWidth + 'px' },
                onClick: this.onClick
            };
            var inputClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, prefixCls + '-input', true), _defineProperty(_classnames3, prefixCls + '-input-active', this.state.isShowPanel), _defineProperty(_classnames3, classPrefix + '-input', true), _defineProperty(_classnames3, classPrefix + '-input-border-waining', validate && validate.ret !== 0), _classnames3));
            var iconClass = classnames((_classnames4 = {}, _defineProperty(_classnames4, prefixCls + '-icon', true), _defineProperty(_classnames4, prefixCls + '-icon-hover', this.state.isShowClearIcon), _classnames4));
            var inputProps = {
                type: 'text',
                value: this.state.newValue ? this.state.newValue.format(format) : '',
                placeholder: placeHolder,
                className: inputClass,
                style: { width: inputWidth + 'px' },
                readOnly: true
            };
            var iconProps = {
                className: iconClass,
                onClick: this.onIconClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave
            };
            var comboboxProps = {
                prefixCls: prefixCls,
                value: this.state.newValue || moment(),
                format: format,
                hourOptions: generateOptions(24, disableTime.disableHours),
                minuteOptions: generateOptions(60, disableTime.disableMins),
                secondOptions: generateOptions(60, disableTime.disableSecs),
                showHour: this.isShowHour(),
                showMinute: this.isShowMinute(),
                showSecond: this.isShowSecond(),
                use12Hours: this.isUse12Hours(),
                onChange: this.onChange
            };
            return React.createElement(
                'div',
                { className: rootClass },
                label ? React.createElement(
                    'div',
                    { className: classPrefix + '-form-label' },
                    label
                ) : null,
                React.createElement(PopperWrap, {
                    ref: function ref(el) {
                        _this2.PopperWrap = el;
                    },
                    containerNode: React.createElement(
                        'div',
                        _extends({}, containerProps, {
                            ref: function ref(el) {
                                _this2.tpContainer = el;
                            }
                        }),
                        React.createElement('input', inputProps),
                        React.createElement('div', iconProps),
                        !noWarning && validate && validate.message && React.createElement(
                            'div',
                            { className: classPrefix + '-form-warning' },
                            React.createElement('i', { className: classPrefix + '-form-error' }),
                            validate.message
                        )
                    ),
                    popupNode: React.createElement(Combobox, comboboxProps),
                    onBodyClick: this.onCloseByWindow,
                    isShowPopup: this.state.isShowPanel,
                    popupNodeZIndex: zIndex,
                    preventOverflowEnabled: preventOverflowEnabled,
                    popupOnBody: popupOnBody
                }),
                star ? React.createElement(
                    'span',
                    { className: prefixCls + '-star' },
                    '*'
                ) : null,
                tips ? React.createElement(
                    'div',
                    { className: classPrefix + '-form-tips' },
                    tips
                ) : null
            );
        }
    }]);

    return TimePicker;
}(Component);

export default TimePicker;


TimePicker.defaultProps = {
    // base
    skin: '',
    className: '',
    style: {},
    // self
    format: 'HH:mm:ss',
    value: null,
    classPrefix: classPrefix,
    placeHolder: '请选择时间',
    disableTime: {},
    onChange: noop,
    onClick: noop,
    preventOverflowEnabled: true
};

TimePicker.propTypes = {
    skin: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    value: PropTypes.string,
    format: PropTypes.string,
    width: PropTypes.number,
    classPrefix: PropTypes.string,
    placeHolder: PropTypes.string,
    disableTime: PropTypes.object,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    onHandleChange: PropTypes.func,
    getValue: PropTypes.func,
    formFlag: PropTypes.bool,
    increment: PropTypes.string,
    name: PropTypes.string,
    tips: PropTypes.node,
    star: PropTypes.bool,
    validate: PropTypes.any,
    label: PropTypes.node,
    noWarning: PropTypes.bool,
    zIndex: PropTypes.number,
    preventOverflowEnabled: PropTypes.bool,
    popupOnBody: PropTypes.bool
};